// Where the board's columns go. On a phone: the tabbed pager, one column in
// view. From 600 px up: today's grid, exactly as ScreenerBoardView always laid
// it out. The columns arrive as children, one per config, so the board builds
// them once for both.

import { Children, type ReactNode } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { PhoneBoard } from './PhoneBoard';

export interface ColumnsHostProps {
    phone: boolean;
    /** One per child, in the same order: the tab names and ids. */
    configs: { id: string; title: string }[];
    /** The desktop grid's style. */
    gridSx: SxProps<Theme>;
    children: ReactNode;
}

export function ColumnsHost({
    phone,
    configs,
    gridSx,
    children,
}: ColumnsHostProps) {
    if (!phone) return <Box sx={gridSx}>{children}</Box>;

    const nodes = Children.toArray(children);
    return (
        <PhoneBoard
            columns={configs.map((config, index) => ({
                id: config.id,
                title: config.title,
                node: nodes[index],
            }))}
        />
    );
}
